export type GetRootComponentsResponse = {
  /**
   * The results of this get_root_component_list response body.
   */
  rootCpntList: RootCpnt[];
};

export type RootCpnt = {
  delFlg: string;
  dipByRgn: string;
  rootCpntId: string;
  rootCpntName: string;
  systemName: string;
  systemId: string;
  subSystemId: string;
  notSystemUsg: string;
  updateDateTimeMRootCpnt: string;
  picAddressList: PicAddress[];
  cpntList: Cpnt[];
  cmpProject: string;
};

export type PicAddress = {
  ichrName: string;
  telNum: string;
  mlAdrs: string;
};

export type Cpnt = {
  cpntId: string;
  cpntName: string;
  delFlg: string;
};
